import ReactDOM from 'react-dom/client';
import './App.css';
import MainApp from './MainApp';

if (process.env.NODE_ENV !== 'development') {
  // eslint-disable-next-line no-console
  console.log = console.error = console.warn = console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('app-site'));
root.render(<MainApp />);
